<div class="main-container centerWithFlex">

    <div class="inner-container">

            <!-----------------------Form Header----------------------->
            <div class="formHeaderRow">
                      <div class="formRow-20">

                      </div> 
                      <div class="formRow-20">

                      </div>  
                      <div class="formRow-20 bothCenter" style="font-size: x-large;font-weight:700 ;">
                        Jobs
                      </div>
                      <div class="formRow-20">

                      </div>
                      <div class="formRow-20 bothCenter">
                          <button style="font-size: 14px;margin-right: 10px;" class="btn btn-outline-secondary rounded-pill button-align" (click)="cancelJob()">Cancel</button>
                          <button style="font-size: 14px;" class="btn btn-outline-secondary rounded-pill button-align" (click)="saveJob()">Submit</button>
                      </div>
            </div>

            <!-----------------------Form Body----------------------->
            <div class="formRow">
                    <div class="formRow-10">

                    </div>
                    <div class="formRow-17 verticalCenter">
                          Catergory
                          <span class="mandatoryAsterisk">&nbsp; *</span>
                    </div>
                    <div class="formRow-17 block-center">
                        <div class="formRow-85 verticalCenter">
                            <select [(ngModel)]="selectedCategory" [tabIndex]="1" class="form-control pointer-cursor full-height" 
                                    (ngModelChange)="selectCategory($event)">
                                <option value='' disabled selected >Select</option>
                                <option *ngFor="let cat of categoryTypes" value={{cat.name}}>
                                    {{cat.name}}</option>
                            </select>
                        </div>
                        <div class="error-field" id="cat-error-div" [ngClass]="{'hidden-field': validCategory}">
                            Category is required
                        </div>
                    </div>
                    <div class="formRow-10">

                    </div>
                    <div class="formRow-17 verticalCenter">
                         Location
                         <span class="mandatoryAsterisk">&nbsp; *</span>
                    </div>
                    <div class="formRow-17 block-center">
                        <div class="formRow-85 verticalCenter">
                            <!-- <select [(ngModel)]="selectedLocation" [tabIndex]="1" class="form-control pointer-cursor full-height" 
                                    (ngModelChange)="selectLocation($event)">
                                <option value='' disabled selected >Select</option>
                                <option *ngFor="let loc of locationList" value={{loc.name}}>
                                    {{loc.name}}</option>
                            </select> -->

                            <input type="text" id="job-location" name="job-location" [tabIndex]="4" (keyup)="valiDateLocation($event)"
                             class="form-control full-height" [(ngModel)]="selectedLocation">

                        </div>
                        <div class="error-field" id="loc-error-div" [ngClass]="{'hidden-field': validLocation}">
                            Location is required
                        </div>
                    </div>
                    <div class="formRow-10">

                    </div>
            </div>

            <div class="formRow">
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                    Job Role
                      <span class="mandatoryAsterisk">&nbsp; *</span>
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <select [(ngModel)]="selectedDomain" [tabIndex]="2" class="form-control pointer-cursor full-height" 
                                (ngModelChange)="selectDomain($event)">
                            <option value='' disabled selected>Select</option>
                            <option *ngFor="let dmain of domainTypes" value={{dmain.name}}>
                                {{dmain.name}}</option>
                        </select>
                    </div>
                    <div class="error-field" id="dm-error-div" [ngClass]="{'hidden-field': validDomain}">
                        Job Role is required
                    </div>
                </div>
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                     Employer
                     <span class="mandatoryAsterisk">&nbsp; *</span>
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <!-- <select [(ngModel)]="selectedEmployer" [tabIndex]="2" class="form-control pointer-cursor full-height" 
                                (ngModelChange)="selectEmployer($event)">
                            <option value='' disabled selected>Select</option>
                            <option *ngFor="let emp of employerList" value={{emp.name}}>
                                {{emp.name}}</option>
                        </select> -->

                        <input type="text" id="job-employer" name="job-employer" [tabIndex]="4" (keyup)="valiDateEmployer($event)"
                        class="form-control full-height" [(ngModel)]="selectedEmployer">

                    </div>
                    <div class="error-field" id="emp-error-div" [ngClass]="{'hidden-field': validEmployer}">
                        Employer is required
                    </div>
                </div>
                <div class="formRow-10">

                </div>
            </div>

            <div class="formRow">
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                      Job Reference ID
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <input type="text" id="job-ref-id" name="job-ref-id" [tabIndex]="4" class="form-control full-height" [(ngModel)]="refId">
                    </div>
                    <div class="error-field hidden-field" id="jr-error-div">
                        No error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                     Contact
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <input type="text" id="job-con" name="job-con" [tabIndex]="4" class="form-control full-height" [(ngModel)]="contact">
                    </div>
                    <div class="error-field hidden-field" id="con-error-div">
                        No error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
            </div>

            <div class="formRow">
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                    Description
                    <span class="mandatoryAsterisk">&nbsp; *</span>
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <input type="text" id="te-desc" name="te-desc" [tabIndex]="4" class="form-control full-height" (keyup)="validateDesc($event)" [(ngModel)]="description">
                    </div>
                    <div class="error-field" id="des-error-div" [ngClass]="{'hidden-field': validDesc}">
                        Description is required
                    </div>
                </div>
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                     Job Links
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <input type="text" id="feed-lnk" name="feed-lnk" [tabIndex]="4" class="form-control full-height" [(ngModel)]="link">
                    </div>
                    <div class="error-field hidden-field" id="lnk-error-div">
                        No error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
            </div>

            <div class="formRow">
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                    Minimum Experience 
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <input type="text" id="yr-exp" name="yr-exp" [tabIndex]="4" class="form-control full-height" [(ngModel)]="yrsOfExp">
                    </div>
                    <div class="error-field hidden-field" id="ye-error-div">
                        No error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                     Reference Email ID
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <input type="text" id="ref-eml" name="ref-eml" [tabIndex]="4" class="form-control full-height" [(ngModel)]="refEmail">
                    </div>
                    <div class="error-field hidden-field" id="r-em-error-div">
                        No error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
            </div>

            <div class="formRow">
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                      Top 3 skills required for this job
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <input type="text" id="job-skl" name="job-skl" [tabIndex]="4" class="form-control full-height" [(ngModel)]="skills">
                    </div>
                    <div class="error-field hidden-field" id="sk-error-div">
                        No error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                     URL to apply
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <input type="text" id="job-ap-url" name="job-ap-url" [tabIndex]="4" class="form-control full-height" [(ngModel)]="applyUrl">
                    </div>
                    <div class="error-field hidden-field" id="ap-error-div">
                        No error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
            </div>

            <div class="formRow">
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                      Publisher want user to contact him
                </div>
                <div class="formRow-17 verticalCenter">
                    <div class="formRow-30 verticalCenter">
                        <input type="radio" [checked]="isContact == true" (click)="setContact(true)">
                        <span>Yes</span>
                    </div>
                    <div class="formRow-30 verticalCenter">
                        <input type="radio" [checked]="isContact == false" (click)="setContact(false)">
                        <span>No</span>
                    </div>
                </div>
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                     Roles and Responsibilities
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 auto-height">
                        <textarea  id="job-de-de" name="job-de-de" [tabIndex]="4" class="form-control full-height textAreaMinHeight" [(ngModel)]="jobDescription">
                        </textarea>
                    </div>
                    <div class="error-field hidden-field" id="jd-error-div">
                        No error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
            </div>

            <div class="formRow">
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                    Tags
              </div>
              <div class="formRow-17 block-center">
                  <div class="formRow-85 auto-height">
                      <mat-form-field style="min-width: 100%;">
                          <mat-chip-list #chipList>
                              <mat-chip *ngFor="let sTag of selectedTags" [selectable]="selectable" [removable]="removable" (removed)="remove(sTag)">
                                  {{sTag.name}}
                                  <i class="fa fa-times-circle float-right" matChipRemove></i>
                              </mat-chip>
                              <input [tabIndex]="2" #searchInput (keyup)="searchTag($event, searchInput)" [matAutocomplete]="auto"
                              [matChipInputFor]="chipList" class="full-height">
                          </mat-chip-list>
                          <mat-autocomplete #auto="matAutocomplete">
                              <mat-option *ngFor="let dmain of tagList" (onSelectionChange)="tagSelected($event, dmain, searchInput)" [value]="dmain.name">
                                  {{dmain.name}}
                              </mat-option>
                          </mat-autocomplete>
                      </mat-form-field>
                  </div>
                  <div class="error-field hidden-field" id="tg-error-div">
                      No error
                  </div>
              </div>
                <div class="formRow-10">

                </div>
            </div>
    </div>

</div>